import { Options, Vue } from 'vue-class-component'
import LeftSideBar from '../LeftSideBar/index.vue'

@Options({
  components: {
    LeftSideBar
  }
})
export default class SekretariatetView extends Vue {}
